module.exports = __webpack_public_path__ + "static/media/app_store.2928664f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/app_store.svg
// module id = 407
// module chunks = 0